import { render, staticRenderFns } from "./ChoreCellHousemate.vue?vue&type=template&id=72fe8a69&scoped=true"
import script from "./ChoreCellHousemate.vue?vue&type=script&lang=js"
export * from "./ChoreCellHousemate.vue?vue&type=script&lang=js"
import style0 from "./ChoreCellHousemate.vue?vue&type=style&index=0&id=72fe8a69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fe8a69",
  null
  
)

export default component.exports